<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #smsCampaignStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CAMPAIGN' | translate }}</ng-template>

      <LOSx-edit-sms-campaign-step
        [smsCampaign]="smsCampaign"
        [smsCampaignTemplate]="smsCampaignTemplate"
        (templateParameters)="setParameters($event)"
      >
      </LOSx-edit-sms-campaign-step>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{ 'labels.inputs.MESSAGE' | translate }}</ng-template>

      <LOSx-campaign-message-step
        [templateParameters]="templateParameters"
        [editCampaignMessage]="smsCampaign.campaignMessage"
      >
      </LOSx-campaign-message-step>
    </mat-step>

    <mat-step state="preview" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>

      <LOSx-campaign-preview-step
        [campaign]="smsCampaign"
        [editedCampaignMessage]="campaignMessage"
        [smsCampaignTemplate]="smsCampaignTemplate"
        (submitEvent)="submit()"
      >
      </LOSx-campaign-preview-step>
    </mat-step>
  </mat-stepper>
</div>
